import { Link } from "react-router-dom";
import { Check, Download, ArrowRight } from "lucide-react";
import client, { API } from "../lib/api";
import { trackAmazonClick, trackEvent } from "../lib/tracking";
import { useEffect, useState } from "react";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";

export default function Grazie() {
  const [amazon, setAmazon] = useState("https://amzn.eu/d/01pW9tnS");

  useEffect(() => {
    client.get("/settings/public").then((r) => setAmazon(r.data.amazon_url)).catch(() => {});
  }, []);

  return (
    <div data-testid="grazie-page" className="bg-nero min-h-screen pt-40 pb-24 grain relative">
      <SEO title="Grazie" path="/grazie" description="La tua guida gratuita è in arrivo." />
      <div className="mx-auto max-w-2xl px-5 sm:px-8 text-center">
        <Reveal>
          <div className="mx-auto h-16 w-16 rounded-full border-2 border-oro flex items-center justify-center mb-8">
            <Check size={26} className="text-oro" />
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-panna">Fatto. Ora sei dentro il calice.</h1>
          <p className="mt-6 text-panna/70 leading-relaxed">
            Ti abbiamo inviato la guida via email. Se non la vedi, controlla lo spam —
            oppure scaricala subito da qui.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <a href={`${API}/lead-magnet/download`} data-testid="grazie-download"
               onClick={() => trackEvent("lead_magnet_download")}
               className="inline-flex items-center justify-center gap-2 rounded-full bg-bordeaux px-8 py-4 font-medium text-panna border border-oro/30 hover:bg-bordeaux-dark transition-colors">
              <Download size={17} /> Scarica il PDF
            </a>
            <a href={amazon} target="_blank" rel="noopener noreferrer"
               onClick={() => trackAmazonClick("grazie")}
               data-testid="grazie-amazon"
               className="inline-flex items-center justify-center gap-2 rounded-full border border-oro/60 px-8 py-4 font-medium text-oro hover:bg-oro/10 transition-colors">
              Nel frattempo: il libro su Amazon <ArrowRight size={16} />
            </a>
          </div>
          <p className="mt-14 text-panna/40 text-sm">
            <Link to="/corsi" className="underline underline-offset-4 hover:text-oro transition-colors">Scopri i corsi</Link>
            {" · "}
            <Link to="/podcast" className="underline underline-offset-4 hover:text-oro transition-colors">Ascolta il podcast</Link>
          </p>
        </Reveal>
      </div>
    </div>
  );
}
